var helveticaHeaderLhCrop = {
  h1: [[0.26, 0.28], 0.26, 0.28, 0.26, 0.26, [0.26, 0.3]],
  h2: [[0.28, 0.28], 0.28, 0.28, 0.28, 0.28, [0.26, 0.3]],
  h3: [[0.28, 0.28], 0.28, 0.28, 0.28, 0.28, [0.25, 0.3]],
  h4: [[0.28, 0.28], 0.28, 0.28, 0.28, 0.26, [0.28, 0.3]],
  h5: [[0.26, 0.28], 0.26, 0.28, [0.26, 0.27], null, 0.28],
  h6: [[0.26, 0.26], 0.26, 0.26, [0.25, 0.27], null, [0.26, 0.3]]
};
var fonts = {
  fonts: {
    body: 'Helvetica, Arial, sans-serif',
    heading: 'Helvetica, Arial, sans-serif'
  },
  fontWeights: {
    light: 300,
    normal: 400,
    bold: 700
  },
  lineHeights: {
    heading: 1.25,
    body: 1.5,
    dense: 1.3
  },
  lhCrops: {
    body: {
      __default: 0.35,
      xxs: [0.5, 0.28],
      'xs-2': 0.35,
      'xs-3': 0.28
    },
    'text-container-expander': 0.3,
    heading: {
      h1: helveticaHeaderLhCrop.h1,
      h2: helveticaHeaderLhCrop.h2,
      h3: helveticaHeaderLhCrop.h3,
      h4: helveticaHeaderLhCrop.h4,
      h5: helveticaHeaderLhCrop.h5,
      h6: helveticaHeaderLhCrop.h6
    },
    monospace: 0.5 // Menlo
  }
};

export { fonts };
//# sourceMappingURL=fonts.esm.js.map
